var _path, _path2, _path3, _path4, _rect, _g, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFoundersCrown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 120 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12_2123)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120 100V0.499992C120 0.223854 119.776 0 119.5 0L98.4809 6.68791C97.8451 6.89018 97.1601 6.87479 96.5341 6.64416L79.1825 0.251459C78.7416 0.0890243 78.2576 0.0870054 77.8154 0.245756L60.0409 6.62634C59.3691 6.86751 58.6333 6.86123 57.9656 6.60862L41.1985 0.264281C40.748 0.0938411 40.2512 0.0916697 39.7993 0.258167L22.4932 6.6341C21.8505 6.87088 21.1461 6.88061 20.4971 6.66167L0.750003 0C0.335788 0 0 0.335783 0 0.749998V100C0 133.137 26.8629 160 60 160C93.1371 160 120 133.137 120 100Z",
    fill: "#8B88A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M116 100V4.49999C116 4.22385 115.776 4 115.5 4L98.5586 10.5883C97.8765 10.8536 97.1209 10.8603 96.4342 10.6073L79.1825 4.25146C78.7416 4.08902 78.2576 4.08701 77.8154 4.24576L60.0409 10.6263C59.3691 10.8675 58.6333 10.8612 57.9656 10.6086L41.1985 4.26428C40.748 4.09384 40.2512 4.09167 39.7993 4.25817L22.6062 10.5925C21.8952 10.8544 21.1114 10.8376 20.4123 10.5454L4.75 4C4.33579 4 4 4.33578 4 4.75V100C4 130.928 29.0721 156 60 156C90.9279 156 116 130.928 116 100Z",
    fill: "#C1BDD5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 20H111V100C111 128.167 88.1665 151 60 151C31.8335 151 9 128.167 9 100V20Z",
    fill: "url(#paint0_linear_12_2123)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M111 28V12.4372C111 12.1958 110.804 12 110.563 12L96.9643 16.0596C96.3335 16.248 95.6581 16.2235 95.0425 15.9901L77.3765 9.29111C76.8846 9.10459 76.339 9.11937 75.858 9.33226L61.1533 15.8396C60.4157 16.166 59.5777 16.1817 58.8285 15.8831L42.2789 9.28694C41.8157 9.10233 41.3003 9.09739 40.8337 9.27309L23.0596 15.9654C22.3997 16.2138 21.6734 16.2219 21.0081 15.9882L9.65589 12C9.29365 12 9 12.2937 9 12.6559V28L57.4411 40.8226C59.1181 41.2666 60.8819 41.2666 62.5589 40.8226L111 28Z",
    fill: "#8B87A7"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_12_2123)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12_2123",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 26,
    width: 159,
    height: 158
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 26,
    width: 70,
    height: 153,
    transform: "rotate(45 114 26)",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12_2123)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 25C9 18.3726 14.3726 13 21 13H99C105.627 13 111 18.3726 111 25V100C111 128.167 88.1665 151 60 151C31.8335 151 9 128.167 9 100V25Z",
    fill: "black",
    fillOpacity: 0.3
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45 23.4318C45 22.7367 45.6916 22.2536 46.3443 22.4929L59.6557 27.3738C59.878 27.4553 60.122 27.4553 60.3443 27.3738L73.6557 22.4929C74.3084 22.2536 75 22.7367 75 23.4318V25.3016C75 25.7211 74.7381 26.096 74.3443 26.2404L60.3443 31.3738C60.122 31.4553 59.878 31.4553 59.6557 31.3738L45.6557 26.2404C45.2619 26.096 45 25.7211 45 25.3016V23.4318Z",
    fill: "#C1BDD5"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M77 106.5L56 77.25H63.9459L77 94.5V106.5Z",
    fill: "#CCCCCC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M77 48L56 77.25H63.9459L77 60V48Z",
    fill: "#F8F8F8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M77 106.5L98 77.25H90.0541L77 94.5V106.5Z",
    fill: "#9F9F9F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M77 48L98 77.25H90.0541L77 60V48Z",
    fill: "#CCCCCC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M63.957 77.249L77.0111 59.999L90.0651 77.249L77.0111 94.499L63.957 77.249Z",
    fill: "#E6E6E6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M43 132.5L22 103.25H29.9459L43 120.5V132.5Z",
    fill: "#CCCCCC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M43 74L22 103.25H29.9459L43 86V74Z",
    fill: "#F8F8F8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M43 132.5L64 103.25H56.0541L43 120.5V132.5Z",
    fill: "#9F9F9F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M43 74L64 103.25H56.0541L43 86V74Z",
    fill: "#CCCCCC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M29.957 103.249L43.0111 85.999L56.0651 103.249L43.0111 120.499L29.957 103.249Z",
    fill: "#E6E6E6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5437 53.899C41.9191 52.3784 44.0809 52.3784 44.4563 53.899L45.2577 57.1455C45.3912 57.6864 45.8136 58.1087 46.3545 58.2423L49.6009 59.0437C51.1216 59.4191 51.1216 61.5809 49.6009 61.9563L46.3545 62.7577C45.8136 62.8912 45.3912 63.3136 45.2577 63.8545L44.4563 67.1009C44.0809 68.6216 41.9191 68.6216 41.5437 67.1009L40.7423 63.8545C40.6087 63.3136 40.1864 62.8912 39.6455 62.7577L36.399 61.9563C34.8784 61.5809 34.8784 59.4191 36.399 59.0437L39.6455 58.2423C40.1864 58.1087 40.6087 57.6864 40.7423 57.1455L41.5437 53.899Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5437 113.399C75.9191 111.878 78.0809 111.878 78.4563 113.399L79.2577 116.645C79.3912 117.186 79.8136 117.609 80.3545 117.742L83.6009 118.544C85.1216 118.919 85.1216 121.081 83.6009 121.456L80.3545 122.258C79.8136 122.391 79.3912 122.814 79.2577 123.354L78.4563 126.601C78.0809 128.122 75.9191 128.122 75.5437 126.601L74.7423 123.354C74.6087 122.814 74.1864 122.391 73.6455 122.258L70.399 121.456C68.8784 121.081 68.8784 118.919 70.399 118.544L73.6455 117.742C74.1864 117.609 74.6087 117.186 74.7423 116.645L75.5437 113.399Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12_2123",
    x1: 60,
    y1: 20,
    x2: 60,
    y2: 151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#726F89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#352042"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_2123"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 160,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_12_2123"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 102,
    height: 122,
    fill: "white",
    transform: "translate(9 29)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoundersCrown);
export default __webpack_public_path__ + "static/media/foundersCrown.8fd03bc76c98b8e4994a0e4f8bbfb724.svg";
export { ForwardRef as ReactComponent };